import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { SetLanguage } from './state/language.action';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private readonly defaultLang = 'fr';
  private readonly supportedLangs = ['fr', 'en', 'esp'];

  private readonly translateService = inject(TranslateService);
  private readonly store = inject(Store);
  private langChangeSubscription: Subscription;
  public currentLang: string = this.defaultLang;

  initializeLanguage() {
    const storedLang = localStorage.getItem('selectedLang');
    if (storedLang && this.supportedLangs.includes(storedLang)) {
      this.setLanguage(storedLang);
    } else {
      this.setLanguage(this.defaultLang);
    }

    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  ngOnDestroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  setLanguage(lang: string) {
    if (this.supportedLangs.includes(lang)) {
      localStorage.setItem('selectedLang', lang);
      this.translateService.use(lang);
      document.documentElement.lang = lang;
      this.currentLang = lang;
      this.store.dispatch(new SetLanguage(lang));
    } else {
      localStorage.setItem('selectedLang', this.defaultLang);
      this.translateService.use(this.defaultLang);
      this.store.dispatch(new SetLanguage(this.defaultLang));
      document.documentElement.lang = this.defaultLang;
      this.currentLang = this.defaultLang;
    }
  }

  getCurrentLang() {
    return this.translateService.currentLang;
  }

  getSupportedLangs() {
    return this.supportedLangs;
  }
}
